import styled from 'styled-components';
import { ButtonWithStates, crTheme } from '@comicrelief/component-library';

// Non-production only: a manual-testing helper to autofill the form.
const AutofillButton = styled(ButtonWithStates)`
  && {
    width: 100%;
    margin-top: 1.5rem;
    background: linear-gradient(135deg, ${crTheme.color('blue')} 0%,rgb(148, 25, 255) 100%);

    &:hover,
    &:focus,
    &:active {
      background: ${crTheme.color('blue_dark')};
    }
  }
`;

export { AutofillButton };
